module.exports = __webpack_public_path__ + "static/media/right-chevron.6cea9b53.svg";